/**
 * Development-only logger. No-op in production.
 * Use for debug/trace logs that should not appear in production.
 */
export const devLog = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};
